import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Merges Tailwind class lists, resolving conflicts (e.g. two competing
// `border-*` colors) by keeping the last one instead of leaving the winner
// to depend on generated CSS order.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
